<template>
    <div id="app">
        <transition name="fade"
                    mode="out-in">
            <router-view></router-view>
        </transition>
    </div>
</template>

<script>
    export default {
        name: 'app',
        components: {}
    }

</script>

<style lang="scss">

    html, body {
        width: 100%;
        height: 100%;
    }

    body {
        margin: 0px;
        padding: 0px;
        /*background: url(assets/bg1.jpg) center !important;
            background-size: cover;*/
        // background: #1F2D3D;
        font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
        font-size: 15px;
        -webkit-font-smoothing: antialiased;
    }

    #app {
        position: absolute;
        top: 0px;
        bottom: 0px;
        width: 100%;
    }

    .el-submenu [class^=fa] {
        vertical-align: baseline;
        margin-right: 10px;
    }

    .el-menu-item [class^=fa] {
        vertical-align: baseline;
        margin-right: 10px;
    }

    .toolbar {
        border-radius: 4px;
        background: #e5e9f2;
        padding: 10px;
        //border:1px solid #dfe6ec;
        margin: 10px 0px;
        .el-form-item {
            margin-bottom: 10px;
        }
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: all .2s ease;
    }

    .fade-enter,
    .fade-leave-active {
        opacity: 0;
    }

</style>

<style>
    body {
        margin: 0;
        padding: 0;
        /*overflow-y: scroll;*/
        /*overflow-x: hidden;*/
        /*font-family: roboto,Helvetica Neue,Helvetica,Arial,PingFang SC,SourceHanSansNormal,Hiragino Sans GB,Source Han Sans,Microsoft YaHei,WenQuanYi Micro Hei,sans-serif;*/
    }

    #app {
    }

    .el-dialog {
        margin: 60px 0 0 230px !important;
        width: calc(100% - 230px) !important;
        height: calc(100% - 60px) !important;
    }
    .el-dialog__title{
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// App.vue?21603dd7